import React from "react";
import { Table } from "react-bootstrap";
import { NUMBER_FORMATS } from "../../../constants/app-constant";
import {
  getCommaSeparatedNumbers,
  getCommaSeparatedNumbersInLocaleFormat,
} from "../../../utility/common-methods";
const InfluencerChart = ({
  chartTitle,
  data,
  onEntityClick,
  isEmbededWidget,
  entityList,
}) => {
  const handleUsernameClick = (e, data) => {
    e.preventDefault();
    e.stopPropagation();
    data && window.open(`https://twitter.com/${data}`, "_blank");
  };
  const handleCountClick = (e, legend, label, from_username, channelType) => {
    try {
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
      };
      let clickedEntity = label;

      let entity =
        entityList &&
        entityList.filter(
          (elm) =>
            clickedEntity == elm.entity_display_name?.trim() ||
            clickedEntity == elm.name || label == elm.entity_name?.trim()
        )[0];
      routeParams.entityId = entity && entity.id.toString();
      routeParams.from_username = from_username;
      routeParams.channel_type = [channelType];
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };
  const convertToInternationalCurrencySystem = (labelValue) => {
    if (!labelValue) return "NA";
    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e9
      ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(2) + "B"
      : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e6
        ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(2) + "M"
        : // Three Zeroes for Thousands
        Math.abs(Number(labelValue)) >= 1.0e3
          ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(2) + "K"
          : Math.abs(Number(labelValue));
  };
  if (data.length < 1)
    return (
      <h6
        style={{
          textAlign: "center",
          marginTop: "25%",
        }}
      >
        {" Overall Snapshot​"}: No data available.
      </h6>
    );
  return (
    <div className="customTableWrap">
      <div className="widgetHeading">
        {" "}
        <div className="tableHeading">
          Overall Snapshot
        </div>
      </div>
      <div className="table-responsive">
        {data && data.length && (
          <Table className="table table-sm table-bordered customTable">
            {data && data.length && (
              <thead>
                <tr className="topicRow">
                  <th className="thTopicName">Company Name</th>
                  <th className="thTopicName">Index</th>
                  <th className="thTopicName">No Of Articles</th>
                  <th className="thTopicName">Reach'000</th>
                  <th className="thTopicName">Visibility Score</th>
                  <th className="thTopicName">Co-Score</th>
                  <th className="thTopicName">Publications Hits</th>
                  <th className="thTopicName">Journlist Hits</th>
                </tr>
              </thead>
            )}
            <tbody>
              {Array.isArray(data) &&
                data.map((item, indexs) => {
                  if (!item) {
                    return null;
                  }
                  const {
                    entity_name,
                    index,
                    co_score,
                    reach1000,
                    visibility_score,
                    publicationhit,
                    noofarticles,
                    journalisthit,
                  } = item || {};
                  return (
                    <>
                      <tr key={indexs}>
                        <td>{entity_name}</td>
                        <td>
                          {convertToInternationalCurrencySystem(
                            parseFloat(index).toFixed(2)
                          )}
                        </td>
                        <td>
                          {convertToInternationalCurrencySystem(noofarticles)}
                        </td>
                        <td>
                          {convertToInternationalCurrencySystem(
                            parseFloat(reach1000).toFixed(2)
                          )}
                        </td>
                        <td>
                          {convertToInternationalCurrencySystem(
                            parseFloat(visibility_score).toFixed(2)
                          )}
                        </td>
                        <td>
                          {" "}
                          {convertToInternationalCurrencySystem(
                            parseFloat(co_score).toFixed(2)
                          )}{" "}
                        </td>
                        <td>
                          {" "}
                          {convertToInternationalCurrencySystem(publicationhit)}
                        </td>
                        <td>
                          {convertToInternationalCurrencySystem(journalisthit)}
                        </td>
                      </tr>
                    </>
                  );
                })}
            </tbody>
          </Table>
        )}
      </div>
    </div>
  );
};

export default InfluencerChart;
